"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autocomplete = void 0;
var react_aria_components_1 = require("react-aria-components");
Object.defineProperty(exports, "Autocomplete", { enumerable: true, get: function () { return react_aria_components_1.Autocomplete; } });
//# sourceMappingURL=Autocomplete.js.map